import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import Button2 from './Button2';
import ContentBox  from './ContentBox';

export default class GridBox extends Component {
	render() {
		const {
			service: { link, a, icon, name, desc },
			buttonLabel,
			onButtonHandlerClick = ()=>{}
		} = this.props;

		return (
			<ContentBox className="service-choose-box">
      			<img className="service-choose-box-img" src={icon} alt="service icon" />
      			<h1>{name}</h1>
      			<p>{desc}</p>

				<div className="service-choose-box-button-container">
      				{link && 
						<Link to={link} onClick={onButtonHandlerClick}>
							<Button2 label={buttonLabel} />
						</Link>
					}
      				{a && 
						<a href={a} target="_blank" rel="noopener noreferrer" onClick={onButtonHandlerClick}>
							<Button2 label={buttonLabel} />
						</a>
					}
				</div>
      		</ContentBox>
			
		);
	}
}